import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'emotion';
import unpick from '../utilities/unpick';
import mapStateToClassName from '../utilities/mapStateToClassName';
import CreditCardNumber from './input/credit-card-number';
import CardSecurityCode from './input/card-security-code';
import CardExpirationDate from './input/card-expiration-date';
import SimpleText from './input/simple-text';
import Password from './input/password';
import NumberInput from './input/number';
import ZipComponent from './input/zip-code';
import Textarea from './input/textarea';
import Checkbox from './input/checkbox';
import Radio from './input/radio';
import Dropdown from './input/dropdown';
import SSNComponent from './input/ssn';
import { CollectError } from '../../config';

const HANDLERS = {
  'card-number': CreditCardNumber,
  'card-security-code': CardSecurityCode,
  'card-expiration-date': CardExpirationDate,
  text: SimpleText,
  password: Password,
  number: NumberInput,
  'zip-code': ZipComponent,
  textarea: Textarea,
  checkbox: Checkbox,
  radio: Radio,
  dropdown: Dropdown,
  ssn: SSNComponent,
};

export default function Component(props) {
  const { fieldState, onUpdate, type } = props;

  const Handler = HANDLERS[type];
  if (typeof Handler !== 'function') {
    throw new CollectError('Invalid field type was provided: ', type);
  }

  const eventProps = {
    onKeyDown: onUpdate,
    onKeyUp: onUpdate,
    onChange: onUpdate,
    onInput: onUpdate,
    onPaste: onUpdate,
    onKeyPress: onUpdate,
    onBlur: onUpdate,
    onFocus: onUpdate,
  };

  let cssClassName = '';

  if (props.css) {
    cssClassName = css`
      ${props.css}
    `;
  }

  const p = unpick(props, ['type', 'onUpdate', 'css', 'fieldState']);

  return (
    <Handler
      className={`${cssClassName} ${mapStateToClassName(fieldState)}`}
      {...p}
      {...eventProps}
      value={fieldState.value}
      isValid={fieldState.isValid}
    />
  );
}

Component.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  type: PropTypes.oneOf(Object.keys(HANDLERS)).isRequired,
  css: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
